import React from "react";
import Layout from "../components/ui/Layout";
import COC from "../components/COC";

const COCPage = () => (
  <Layout>
    <COC />
  </Layout>
);

export default COCPage;
